window.localeDateFormat = {
  regex: /(19|20)\d\d[- \/.](0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])/,
  placeholder: '年/月/日',
  dateFormat: 'yy/mm/dd'
};
